import { Component, OnInit } from '@angular/core';
//import { AdataService } from '../../../shared/adata.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/user.service';

@Component({
  selector: 'app-validate-accounts',
  templateUrl: './validate-accounts.component.html',
  styleUrls: ['./validate-accounts.component.css']
})
export class ValidateAccountsComponent implements OnInit {

  data: any = {};
  c: any = {};
  l: any = {};
  b: any = {};
  BranchCode:any;
  PigmyBranchList: any
  AccountCode: any;
  AccountTypeList: any
  PigmySubBranchList:any
  PigmyAccountList:any
  LedgerTypeList:any=[];
  PigmyCollectionValidationList:any = [];
  console: any;
  tot: any;
  constructor(private service: UserService, private router: Router, private route: ActivatedRoute)
   {

   }

  ngOnInit() 
  { 
     this.GetPigmyBranchList()
     this.getAllACountTypeList()
     this.getAllLedgerList()
     this.getAllSubLedgerList()
     this.getAllAccountList()

  }
  GetPigmyBranchList() 
  {
    debugger;
    this.data = this.service.PigmyBranchList();
    this.data.subscribe(
      (response) => {
        this.PigmyBranchList = response.Pigmy_Branch;
        console.log('PigmyBranchList');
        console.log(response);
      })
  }
  getAllACountTypeList() {

    debugger;
    this.data = this.service.AllACountType();
    this.data.subscribe(
      (response) => {
        this.AccountTypeList = response.AccountTypeModel;
        console.log('AccountTypeList');
        console.log(response);
      })
  }


  getAllLedgerList() {

    debugger;
    this.data = this.service.GetAllLedgerType();
    this.data.subscribe(
      (response) => {
        this.LedgerTypeList = response.LedgerValidation;
        console.log('LedgerTypeList');
        console.log(this.LedgerTypeList);
      })
  }

  getAllSubLedgerList()
  {
    // this.data = this.service.SubBranchList();
    // this.data.subscribe(
    //   (response) => {
    //     this.PigmySubBranchList = response.SubLedgerModel;
    //     console.log('PigmySubBranchList');
    //     console.log(this.PigmySubBranchList);
      //})

    this.data = this.service.SubBranchList();
    this.data.subscribe(
      (response) => {
        this.PigmySubBranchList = response.SubLedgerValidation;
        console.log('PigmySubBranchList');
        console.log(response);
      })
  }
  ValidatePigmayDetails(BranchCode:any,ModualCode:any,L_CODE:any,GLSUB_ID:any,Account_Number:any)
  {
    debugger; 
    this.data = this.service.GetallPigmyValidationlist(BranchCode,ModualCode,L_CODE,GLSUB_ID,Account_Number);
    this.data.subscribe(
      (response: any) => 
      {
        debugger;
        this.PigmyCollectionValidationList = response;
        this.console.log(response.PigmayCollectionValidationModel);
        //console.log('Caste List');
        console.log(this.PigmyCollectionValidationList);
        //document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        //document.getElementById('loader-spinner').style.display = "none";
      }
    );   
  }
  getAllAccountList()
  {
    this.data = this.service.PigAccountList();
    this.data.subscribe(
      (response) => {
        this.PigmyAccountList = response.PigmayManualAccount;
        console.log('PigmyAccountList');
        console.log(response);
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/general-transaction/validate-accounts/validate-accounts/validate-accounts.component.ts